module.exports = {
    "collectionLabel": `Forslag`
};


//# sourceMappingURL=da-DK.main.js.map
